import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { RoleEditSchema } from "../../../ValidationSchema";

const PermissionEdit = () => {
  const location = useLocation();
  const Navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    name: "",
    permission_name: "",
  });

  const GetUserData = () => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/permission/edit-get?id=${location?.state?.id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setInitialValues({
            name: res?.data?.data?.name,
            permission_name: res?.data?.data?.permission_name,
          });
        }
      })
      .catch((err) => {

        const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
        const STATUS = [401, 403];
        if (
          STATUS.includes(err.response.status) ||
          MSG.includes(err.response.data.msg)
        ) {
          localStorage.clear();
          Navigate("/admin/login");
        } else {
          toast.error(err?.response?.data?.msg);
        }
      });
  };

  const AddRoom = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: RoleEditSchema,

    onSubmit: (values, action) => {
      let data = {
        id: location?.state?.id,
        name: values.name,
        permission_name: values.permission_name,
      };
      axios
        .post(`${process.env.REACT_APP_URL}/admin/permission/store`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            toast.success(`Permission Updated Successfully`);
            Navigate("/admin/permission", { state: res.data.msg });
          }
        })
        .catch((err) => {
          toast.error(err.response.data.msg);
        });
    },
  });

  useEffect(() => {
    GetUserData();
  }, []);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Edit Permission</h1>
          <p className="al-sub">Update this permission.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={AddRoom.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg></div>
            <h3 className="al-cardhead__title">Permission Details</h3>
          </div>
          <div className="al-form">
            <div>
              <label className="al-label">Name</label>
              <input className="al-input" type="text" placeholder="Enter Name"
                value={AddRoom.values.name} onChange={AddRoom.handleChange} onBlur={AddRoom.handleBlur} name="name" />
              {AddRoom.errors.name && AddRoom.touched.name ? (
                <div className="al-err">{AddRoom.errors.name}</div>
              ) : null}
            </div>
            <div>
              <label className="al-label">Permission Name</label>
              <input className="al-input" type="text" placeholder="Enter Permission Name"
                value={AddRoom.values.permission_name} onChange={AddRoom.handleChange} onBlur={AddRoom.handleBlur} name="permission_name" />
              {AddRoom.errors.permission_name && AddRoom.touched.permission_name ? (
                <div className="al-err">{AddRoom.errors.permission_name}</div>
              ) : null}
            </div>
          </div>
          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
              Save Changes
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default PermissionEdit;
